import magnifiAPIInstance from "./apiInstance";

export const mediaLiveOutputTemplateAPIs = {
  getTemplates: ({ entityId, pageNo, limit, type, search = "" }) =>
    magnifiAPIInstance.get(
      `/medialive_output_template/${entityId}?pageNo=${pageNo}&limit=${limit}&outputTemplateType=${type}&search=${search}`,
    ),
  addMediaTemplate: ({ payload }) => magnifiAPIInstance.post("create_medialive_output_template", payload),
  editMediaTemplate: ({ payload }) => magnifiAPIInstance.post("edit_medialive_output_template", payload),
  deleteMediaTemplate: ({ payload }) => magnifiAPIInstance.delete(`delete_medialive_output_template/${payload?.id}`),
};
